/**
 * Gtag-specific enums for Google Analytics 4
 * These enums contain GA4 standard event types and parameters
 */

// GA4 Standard Event Types
export enum GtagEventType {
  PAGE_VIEW = 'page_view',

  // User engagement
  BUTTON_CLICK = 'button_click',
  FORM_SUBMIT = 'form_submit',
  SCROLL = 'scroll',

  // E-commerce
  VIEW_ITEM = 'view_item',
  ADD_TO_CART = 'add_to_cart',
  REMOVE_FROM_CART = 'remove_from_cart',
  BEGIN_CHECKOUT = 'begin_checkout',
  PURCHASE = 'purchase',

  // Custom events
  CUSTOM_EVENT = 'custom_event',

  // User actions
  LOGIN = 'login',
  SIGN_UP = 'sign_up',
  SEARCH = 'search',

  // Content interaction
  VIEW_ITEM_LIST = 'view_item_list',
  SELECT_ITEM = 'select_item',
  VIEW_PROMOTION = 'view_promotion',
  SELECT_PROMOTION = 'select_promotion',

  // Trading Hours Events
  TRADING_HOURS_UPDATE = 'trading_hours_update',
  TRADING_HOURS_DELETE = 'trading_hours_delete',
  TRADING_HOURS_VIEW = 'trading_hours_view',
  TRADING_HOURS_CREATE = 'trading_hours_create',
  TRADING_HOURS_EDIT = 'trading_hours_edit',
  TRADING_HOURS_BULK_UPDATE = 'trading_hours_bulk_update'
}

// GA4 Standard Parameters
export enum GtagParameter {
  PAGE_TITLE = 'page_title',
  PAGE_LOCATION = 'page_location',
  PAGE_TYPE = 'page_type',
  SEND_PAGE_VIEW = 'send_page_view',

  // User parameters
  USER_ID = 'user_id',
  USER_PROPERTIES = 'user_properties',

  // Event parameters
  EVENT_CATEGORY = 'event_category',
  EVENT_LABEL = 'event_label',
  EVENT_VALUE = 'event_value',

  // Custom parameters
  CUSTOM_PARAM_1 = 'custom_param_1',
  CUSTOM_PARAM_2 = 'custom_param_2',
  CUSTOM_PARAM_3 = 'custom_param_3',

  // E-commerce parameters
  ITEM_ID = 'item_id',
  ITEM_NAME = 'item_name',
  ITEM_CATEGORY = 'item_category',
  ITEM_VARIANT = 'item_variant',
  ITEM_BRAND = 'item_brand',
  PRICE = 'price',
  CURRENCY = 'currency',
  QUANTITY = 'quantity',

  // Transaction parameters
  TRANSACTION_ID = 'transaction_id',
  VALUE = 'value',
  TAX = 'tax',
  SHIPPING = 'shipping',

  // Content parameters
  CONTENT_TYPE = 'content_type',
  CONTENT_ID = 'content_id',
  CONTENT_NAME = 'content_name',

  // Search parameters
  SEARCH_TERM = 'search_term',

  // Form parameters
  FORM_ID = 'form_id',
  FORM_NAME = 'form_name',

  // Button parameters
  BUTTON_ID = 'button_id',
  BUTTON_NAME = 'button_name',
  BUTTON_TEXT = 'button_text',

  // Trading Hours parameters
  TRADING_HOURS_TYPE = 'trading_hours_type',
  TRADING_HOURS_PERIOD = 'trading_hours_period',
  TRADING_HOURS_MENU = 'trading_hours_menu',
  TRADING_HOURS_DAYS = 'trading_hours_days',
  TRADING_HOURS_START_DATE = 'trading_hours_start_date',
  TRADING_HOURS_END_DATE = 'trading_hours_end_date',
  TRADING_HOURS_START_TIME = 'trading_hours_start_time',
  TRADING_HOURS_END_TIME = 'trading_hours_end_time',
  TRADING_HOURS_CHANNEL = 'trading_hours_channel',
  TRADING_HOURS_REASON = 'trading_hours_reason',
  TRADING_HOURS_RESTAURANT_ID = 'trading_hours_restaurant_id',
  TRADING_HOURS_RESTAURANT_NAME = 'trading_hours_restaurant_name',
  TRADING_HOURS_SECTION_ID = 'trading_hours_section_id',
  TRADING_HOURS_SECTION_NAME = 'trading_hours_section_name',
  TRADING_HOURS_OVERRIDE_ID = 'trading_hours_override_id',
  TRADING_HOURS_BULK_COUNT = 'trading_hours_bulk_count'
}

// Gtag Configuration Options
export enum GtagConfig {
  MEASUREMENT_ID = 'measurement_id',
  SEND_PAGE_VIEW = 'send_page_view',
  CUSTOM_MAP = 'custom_map',
  COOKIE_FLAGS = 'cookie_flags',
  COOKIE_DOMAIN = 'cookie_domain',
  COOKIE_EXPIRES = 'cookie_expires',
  COOKIE_UPDATE = 'cookie_update',
  COOKIE_PREFIX = 'cookie_prefix',
  USER_ID = 'user_id',
  USER_PROPERTIES = 'user_properties'
}

// Gtag Command Types
export enum GtagCommand {
  CONFIG = 'config',
  EVENT = 'event',
  SET = 'set',
  CONSENT = 'consent',
  GET = 'get'
}

// Gtag Consent Types
export enum GtagConsent {
  DEFAULT = 'default',
  UPDATE = 'update'
}

// Gtag Consent Parameters
export enum GtagConsentParameter {
  ANALYTICS_STORAGE = 'analytics_storage',
  AD_STORAGE = 'ad_storage',
  FUNCTIONALITY_STORAGE = 'functionality_storage',
  PERSONALIZATION_STORAGE = 'personalization_storage',
  SECURITY_STORAGE = 'security_storage'
}

// Gtag Consent Values
export enum GtagConsentValue {
  GRANTED = 'granted',
  DENIED = 'denied'
}
